import "rxjs/add/operator/map";

import { Types } from "../reducer";
import { Creators as DataCreators } from "../../data/reducer";

export default (action$, store) =>
  action$.ofType(Types.SET_CURRENT_REGISTRATION).map(action => {
    localStorage.setItem("currentRegistrationId", action.registrationId);
    return DataCreators.loadPath(`registrations/${action.registrationId}`);
  });



// WEBPACK FOOTER //
// ./src/registration/epics/setCurrentRegistration.js